import React, { useState, useEffect } from "react";
import { BiLogOut } from "react-icons/bi";
import {
  FaBars,
  FaChartBar,
  FaBook,
  FaListAlt,
  FaExchangeAlt,
  FaArrowRight,
  FaArrowDown,
  FaUsers,
  FaTag,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Layout = ({ title, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("");
  const [showSubmenu, setShowSubmenu] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 1024;
    setIsSidebarOpen(isDesktop);

    const path = location.pathname;

    // Logic penentuan menu aktif
    if (path.includes("dashboard")) setActiveMenu("dashboard");
    else if (
      path.includes("anggota") ||
      path.includes("penerbit") ||
      path.includes("administrator")
    )
      setActiveMenu("masterData");
    else if (path.includes("buku") || path.includes("kategori"))
      setActiveMenu("katalogBuku");
    else if (path.includes("peminjaman") || path.includes("kembali"))
      setActiveMenu("dataTransaksi");
    // Cukup satu cek ini. Karena 'laporangamifikasi' mengandung kata 'laporan',
    // maka kedua halaman akan mengaktifkan menu induk "laporanPerpustakaan".
    else if (path.includes("laporan")) 
      setActiveMenu("laporanPerpustakaan");
    else if (path.includes("pesan")) 
      setActiveMenu("pesan");
  }, [location.pathname]);

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    setShowSubmenu((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className="layout-wrapper"
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f5f5f5",
      }}
    >
      {/* Top Navigation Bar */}
      <nav
        className="navbar is-info"
        role="navigation"
        aria-label="main navigation"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 10,
          background: "#209CEE",
        }}
      >
        <div
          className="navbar-brand is-flex is-align-items-center"
          style={{ width: "100%" }}
        >
          {/* Burger menu hanya tampil di mobile */}
          <button
            className="navbar-item is-hidden-desktop"
            onClick={toggleSidebar}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              cursor: "pointer",
            }}
          >
            <FaBars />
          </button>
          <p
            className="navbar-item is-size-5 has-text-white"
            style={{ fontWeight: "bold" }}
          >
            Perpustakaan
          </p>
        </div>
      </nav>

      <div style={{ display: "flex", flexGrow: 1, marginTop: "52px" }}>
        {/* Left Sidebar */}
        <aside
          className={`sidebar ${isSidebarOpen ? "" : "is-hidden-mobile"}`}
          style={{
            width: isSidebarOpen ? "220px" : "0",
            background: "#364150",
            color: "white",
            overflow: "hidden",
            transition: "width 0.3s ease-in-out",
          }}
        >
          {/* Profil Admin */}
          <div
            style={{
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <img
              src="/fotoadmin.jpg"
              alt="Admin"
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                marginRight: "10px",
              }}
            />
            <p style={{ fontWeight: "bold" }}>Admin</p>
          </div>

          <ul style={{ listStyle: "none", padding: 0, marginTop: "1rem" }}>
            {/* Dashboard */}
            <li
              className={`menu-item ${
                activeMenu === "dashboard" ? "is-active" : ""
              }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "dashboard"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/dashboard"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaChartBar style={{ marginRight: "5px" }} />
                Dashboard
              </Link>
            </li>

            {/* Master Data */}
            <li
              className={`menu-item ${
                activeMenu === "masterData" ? "is-active" : ""
              }`}
              onClick={() => handleMenuClick("masterData")}
              style={{
                padding: "8px",
                marginBottom: "5px",
                cursor: "pointer",
                background:
                  activeMenu === "masterData" ? "#192A56" : "transparent",
              }}
            >
              <FaUsers style={{ marginRight: "5px" }} /> Master Data
              <span style={{ float: "right" }}>
                {showSubmenu["masterData"] ? <FaArrowDown /> : <FaArrowRight />}
              </span>
            </li>
            {showSubmenu["masterData"] && (
              <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/dataanggota"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Data Anggota Aktif
                  </Link>
                </li>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/historyanggota"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Data Anggota Non-Aktif
                  </Link>
                </li>
              </ul>
            )}

            {/* Katalog Buku */}
            <li
              className={`menu-item ${
                activeMenu === "katalogBuku" ? "is-active" : ""
              }`}
              onClick={() => handleMenuClick("katalogBuku")}
              style={{
                padding: "8px",
                marginBottom: "5px",
                cursor: "pointer",
                background:
                  activeMenu === "katalogBuku" ? "#192A56" : "transparent",
              }}
            >
              <FaBook style={{ marginRight: "5px" }} /> Kelola Buku
              <span style={{ float: "right" }}>
                {showSubmenu["katalogBuku"] ? <FaArrowDown /> : <FaArrowRight />}
              </span>
            </li>
            {showSubmenu["katalogBuku"] && (
              <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/databuku"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Data Buku
                  </Link>
                </li>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/kategoribuku"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Kategori Buku
                  </Link>
                </li>
              </ul>
            )}

            {/* Data Transaksi */}
            <li
              className={`menu-item ${
                activeMenu === "dataTransaksi" ? "is-active" : ""
              }`}
              onClick={() => handleMenuClick("dataTransaksi")}
              style={{
                padding: "8px",
                marginBottom: "5px",
                cursor: "pointer",
                background:
                  activeMenu === "dataTransaksi" ? "#192A56" : "transparent",
              }}
            >
              <FaExchangeAlt style={{ marginRight: "5px" }} /> Data Peminjaman
              <span style={{ float: "right" }}>
                {showSubmenu["dataTransaksi"] ? (
                  <FaArrowDown />
                ) : (
                  <FaArrowRight />
                )}
              </span>
            </li>
            {showSubmenu["dataTransaksi"] && (
              <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/datapeminjaman"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Data Peminjaman
                  </Link>
                </li>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/datakembali"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Data Pengembalian
                  </Link>
                </li>
              </ul>
            )}

            {/* Laporan Perpustakaan (Gabungan) */}
            <li
              className={`menu-item ${
                activeMenu === "laporanPerpustakaan" ? "is-active" : ""
              }`}
              onClick={() => handleMenuClick("laporanPerpustakaan")}
              style={{
                padding: "8px",
                marginBottom: "5px",
                cursor: "pointer",
                background:
                  activeMenu === "laporanPerpustakaan"
                    ? "#192A56"
                    : "transparent",
              }}
            >
              <FaListAlt style={{ marginRight: "5px" }} /> Laporan Perpustakaan
              <span style={{ float: "right" }}>
                {showSubmenu["laporanPerpustakaan"] ? (
                  <FaArrowDown />
                ) : (
                  <FaArrowRight />
                )}
              </span>
            </li>
            {showSubmenu["laporanPerpustakaan"] && (
              <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/laporan"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Laporan
                  </Link>
                </li>
                {/* MENU BARU: Laporan Gamifikasi sekarang ada di sini */}
                <li style={{ padding: "6px" }}>
                  <Link
                    to="/laporangamifikasi"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Laporan Gamifikasi
                  </Link>
                </li>
              </ul>
            )}

            {/* Logout */}
            <li style={{ padding: "8px", marginBottom: "5px" }}>
              <button
                onClick={handleLogout}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <BiLogOut style={{ marginRight: "5px" }} /> Keluar
              </button>
            </li>
          </ul>
        </aside>

        {/* Main Content Area */}
        <main style={{ flex: 1, padding: "2rem", paddingTop: "1rem" }}>
          <h1 className="title is-4">{title}</h1>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;